<template lang="pug">
textarea.form-control.autoCompleteUsers(ref='input', :placeholder="placeholder")
</template>
<script>
import $ from 'jquery'
import {mapGetters} from 'vuex'
import api from '@/utils/api'
import Vue from 'vue'
import VueObjectImg from '@/components/shared/VueObjectImg'
import _ from 'lodash'

import MouseMixin from '@/components/shared/MouseMixin'

export default {
  props: {
    showGroops: {
      type: String,
      default: 'mine' // all, mine or none
    },
    showUsers: {
      type: String,
      default: 'mine' // all, mine or none
    },
    showEmails: {
      type: Boolean,
      default: true
    },
    acceptNewUser: {
      type: Boolean,
      default: true
    },
    acceptNewGroop: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    container: {
      default: '#body'
    }
  },
  data () {
    return {}
  },
  components: {},
  mixins: [MouseMixin],
  created () {},
  mounted () {
    let contacts = []
    api.get('/contacts').then(response => {
      contacts = response.data.contacts
      // console.log(contacts)
    })
    let lastTime = Date.now()
    let that = this
    $(this.$refs.input).textcomplete([{
      match: /^(.+)$/,
      search: (term, callback) => {
        lastTime = Date.now()
        let oldLastTime = lastTime
        let promises = []
        let foundGroups = []
        if (this.showGroops !== 'none') {
          foundGroups = $.map(this.groops, function (group) {
            if (group.name.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) >= 0) { return group } else { return null }
          })
        }
        let foundAllGroups = []
        if (this.showGroops === 'all') {
          promises.push(this.$store.dispatch('groops/publicGroopsWithTexts', [term]).then((publicGroups) => {
            _.each(publicGroups, (g) => foundAllGroups.push(g))
          }))
        }
        let foundContacts = []
        if (this.showUsers !== 'none') {
          foundContacts = $.map(contacts, function (contact) {
            if (contact.name.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) >= 0) { return contact } else { return null }
          })
        }
        let foundAllUsers = []
        if (this.showUsers === 'all') {
          promises.push(api.get('users', {params: {
            text: term
          }}).then((response) => {
            _.each(response.data.users, (u) => foundAllUsers.push(u))
          }))
        }
        let found = []
        if (this.acceptNewUser) {
          found.push({kind: 'newUser', id: term, name: term})
        }
        if (this.acceptNewGroop) {
          found.push({kind: 'newGroop', id: term, name: term})
        }
        found = found.concat(foundGroups)
        found = found.concat(foundContacts)
        if (!this.acceptNewUser && this.showEmails && /\S+@\S+\.\S+/.test(term)) {
          found.push({kind: 'email', id: term, name: term})
        }
        if (promises.length > 0) {
          found.push({kind: 'loading'})
        }
        callback(found)
        Promise.all(promises).then(() => {
          if (oldLastTime !== lastTime) {
            return
          }
          if (promises.length > 0) {
            found.splice(-1, 1)
          }
          found = found.concat(foundAllGroups)
          found = found.concat(foundAllUsers)
          found = _.uniqBy(found, (el) => {
            return el.kind + el.id
          })
          return callback(found)
        })
      },
      index: 1,
      template (element) {
        let icon = ''
        let help = ''
        if (element.kind === 'loading') {
          icon = "<i class='fa fa-refresh fa-spin loading'></i>&nbsp;"
        }
        if (element.kind === 'email') {
          icon = "<i class='fa fa-envelope'></i>&nbsp;"
        }
        if (element.kind === 'newUser') {
          icon = "<i class='fa fa-user-plus'></i>&nbsp;"
          help = that._i18n.t('AutoCompleteUser.newUser')
        }
        if (element.kind === 'newGroop') {
          icon = "<i class='fa fa-users'></i>&nbsp;"
          help = that._i18n.t('AutoCompleteUser.newGroup')
        }
        if (element.kind === 'group') {
          let vm = new Vue({
            template: '<vue-object-img :object="group"></vue-object-img>',
            components: {
              VueObjectImg
            },
            data: {
              group: element
            }
          }).$mount()
          icon = vm.$el.outerHTML
          help = element.pageSentence
        }
        if (element.kind === 'user') {
          let vm = new Vue({
            template: '<vue-object-img :object="user"></vue-object-img>',
            components: {
              VueObjectImg
            },
            data: {
              user: element
            }
          }).$mount()
          icon = vm.$el.outerHTML
        }
        let html = icon + _.escape(element.name)
        if (help) {
          html += '<div class="helpBlock">' + help + '</div>'
        }
        return html
      },
      replace: (element, event) => {
        this.consumeMouseEvents()
        if (element.kind === 'loading') {
          return
        }
        // if (this.conversation.participants.indexOf(element) === -1) {
        //   this.conversation.participants.push(element)
        // }
        // taggle.add(element.kind + element.id)
        this.$emit('select', element)
        $(this.$refs.input).val('')
        return ''
      },
      noResultsMessage: 'Entrez une adresse email valide'
    }], {
      appendTo: this.container,
      dropdownClassName: 'dropdown-menu textcomplete-dropdown doNotDesactiveOnClick'
    })
    $(this.$refs.input).on('keyup', (event) => {
      let $input = $(this.$refs.input)
      if ($input.val()) {
        if (event.keyCode === 13) { // enter
          $input.val($input.val().replace(/(\r|\n)/g, ''))
        }
      }
    })
  },
  destroyed () {},
  computed: {
    ...mapGetters('user', [
      'user'
    ]),
    ...mapGetters('groops', [
      'groops'
    ])
  },
  methods: {
    isNewGroup (element) {
      return element.kind === 'newGroop'
    },
    isGroup (element) {
      return element.kind === 'group'
    },
    isNewUser (element) {
      return element.kind === 'newUser'
    },
    isEmail (element) {
      return element.kind === 'newUser'
    }
  },
  filters: {},
  watch: {}
}
</script>
<style lang="sass">
textarea.autoCompleteUsers
  height: 35px
  resize: none
.textcomplete-item
  i.fa:not(.loading)
    width: 35px
    height: 20px
    text-align: center
  i.fa.loading
    opacity: 0.6
  .helpBlock
    margin-left: 38px
    opacity: 0.7
    font-size: 0.7em
    font-style: italic
</style>



// WEBPACK FOOTER //
// AutoCompleteUser.vue?64c9056e